import { render } from "./ProductCategories.vue?vue&type=template&id=26bd1a44&scoped=true"
import script from "./ProductCategories.vue?vue&type=script&lang=js"
export * from "./ProductCategories.vue?vue&type=script&lang=js"

import "./ProductCategories.vue?vue&type=style&index=0&id=26bd1a44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26bd1a44"]])

export default __exports__